export const LIMITS_REMINDER_LAST_GAME_ID_CACHE_KEY = "limitsReminderLastGameId";
export const LIMITS_REMINDER_MODAL_ID = "limitsReminderModalId";
